import validate from "/var/www/html/fullstack-saas/frontend/node_modules/.pnpm/nuxt@3.19.1_@parcel+watcher@2.5.1_@vue+compiler-sfc@3.5.21_db0@0.3.2_eslint@9.35.0_jiti_73c3980b6ddde6b6ae6d2a92255ef75b/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/var/www/html/fullstack-saas/frontend/node_modules/.pnpm/nuxt@3.19.1_@parcel+watcher@2.5.1_@vue+compiler-sfc@3.5.21_db0@0.3.2_eslint@9.35.0_jiti_73c3980b6ddde6b6ae6d2a92255ef75b/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/var/www/html/fullstack-saas/frontend/middleware/auth.ts"),
  guest: () => import("/var/www/html/fullstack-saas/frontend/middleware/guest.ts"),
  permission: () => import("/var/www/html/fullstack-saas/frontend/middleware/permission.ts")
}